import React from "react";
import moment from "moment";
import { Form, Row, Col, Input, InputNumber, DatePicker, Spin, Select, Radio, TreeSelect } from "antd";

import "./style.css";

const webConfig = require('../../config.json');


export default class DaynamicForm extends React.Component {

	componentWillReceiveProps(nextProps) {
		console.log(nextProps)
	}
	formColumn = []
	peopleMap = []

	selectEmployee = value => this.props.selectEmployee({ real_name: value })

	setEmployee = (key, value, event) => this.props.form.setFieldsValue({
		[key]: event.props.employee_id
	})

	setPeople = (key, value, event) => console.log(key, value, event)

	changePeople = (key, value, event) => {
		let employee_ids = [];
		event.forEach(e => {
			if (e.props.employee_id) {
				employee_ids.push(e.props.employee_id)
			} else {
				this.props.dataSource[key].forEach(person => {
					if (person.text === e.props.value) {
						employee_ids.push(person.id)
					}
				})
			}
		})
		this.props.form.setFieldsValue({
			employee_ids: employee_ids
		})
	}

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
					{item.children.length !== 0 && this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

	render() {
		this.formColumn = [];
		let formColumn = [];
		let overflowAttr = "auto";

		if (this.props.overflow) {
			overflowAttr = this.props.overflow;
		}
		if ("function" === typeof this.props.column) {
			formColumn = this.props.column()
		} else {
			formColumn = this.props.column
		}
		formColumn.forEach(column => {
			let columnItem = {
				type: "input",
				span: 12,
				labelWidth: "120px",
				valueWidth: "280px",
				valueWidthSelect: "260px",
				required: true,
				rules: {},
				hide: false,
				...column
			}
			if (!columnItem.valueKey) {
				columnItem.valueKey = columnItem.key;
			}

			this.formColumn.push(columnItem);
		})



		return (
			<div className="app-modal-item" style={{ overflow: overflowAttr }}>
				{(() => {
					switch (this.props.loadStatus) {
						case "reload":
						case "loaded":
							return (
								<Form layout="inline">
									<Row>
										{this.formColumn.map((column, index) => {
											switch (column.type) {
												case "input":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(<Input {...column.rules}
																	placeholder={"请输入" + column.label}
																	style={{ width: column.valueWidth }} />)}
															</Form.Item>
														</Col>
													)
												case "textarea":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(<Input.TextArea {...column.rules}
																	placeholder={"请输入" + column.label}
																	style={{ width: column.valueWidth }} />)}
															</Form.Item>
														</Col>
													)
												case "number":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(<InputNumber {...column.rules}
																	placeholder={"请输入" + column.label}
																	style={{ width: column.valueWidth }} />)}
															</Form.Item>
														</Col>
													)
												case "text":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<div style={{ margin: "0 auto 24px auto", display: "flex" }}>
																<span style={{ flex: 1 }}></span>
																<span style={{ width: column.labelWidth, height: "39px", lineHeight: "39px", textAlign: "right" }}>
																	{column.label}
																	<span style={{ margin: "0px 8px 0px 2px" }}>:</span>
																</span>
																<span style={{ width: column.valueWidth, height: "39px", lineHeight: "39px", textAlign: "left" }}>
																	{this.props.dataSource[column.valueKey]}
																</span>
																<span style={{ flex: 1 }}></span>
															</div>
														</Col>
													)
												case "textex":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "", textAlign: "left" }}>
															<div style={{ display: "flex" }}>

																<span style={{ height: "39px", lineHeight: "39px", textAlign: "right" }}>
																	{column.label}
																	<span style={{ margin: "0px 8px 0px 2px" }}>:</span>
																</span>
																<span style={{ height: "39px", lineHeight: "39px", textAlign: "left" }}>
																	{this.props.dataSource[column.valueKey]}
																</span>

															</div>
														</Col>
													)
												case "textArray":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "", textAlign: "left" }}>
															<div style={{ display: "flex" }}>

																<span style={{ height: "39px", lineHeight: "39px", textAlign: "right" }}>
																	{column.label}
																	<span style={{ margin: "0px 8px 0px 2px" }}>:</span>
																</span>
																<span style={{ height: "39px", lineHeight: "39px", textAlign: "left" }}>

																	{column.valueKey.map(key => {
																		return (this.props.dataSource[key])
																	})}

																</span>

															</div>
														</Col>
													)
												case "title":
													return (
														<Col key={index} span={24} style={{ textAlign: "left" }}>
															<span style={{ height: "32px", lineHeight: "32PX" }}>
																{column.label}
															</span>
															<hr />
														</Col>
													)
												case "date":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey] ?
																		moment(this.props.dataSource[column.valueKey]) : null
																})(<DatePicker {...column.rules} 
																	style={{ width: column.valueWidth }} />)}
															</Form.Item>
														</Col>
													)
													
												case "month":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey] ?
																		moment(this.props.dataSource[column.valueKey]) : null
																})(<DatePicker.MonthPicker {...column.rules}
																	style={{ width: column.valueWidth }} />)}
															</Form.Item>
														</Col>
													)
												case "person":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item >
																{this.props.form.getFieldDecorator(column.key, {
																	initialValue: this.props.dataSource[column.key]
																})(<Input style={{ display: "none" }} />)}
															</Form.Item>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.valueKey, {
																	rules: [{
																		required: column.required,
																		message: '请输入' + column.label
																	}],
																	initialValue: this.props.dataSource[column.valueKey]
																})(
																	<Select mode="combobox"
																		{...column.rules}
																		style={{ width: column.valueWidth }}
																		onSearch={this.selectEmployee}
																		filterOption={false}
																		placeholder={"请输入" + column.label}
																		onSelect={this.setEmployee.bind(this, column.key)} >
																		{this.props.employees &&
																			this.props.employees.Data.map(employee => (
																				<Select.Option key={employee.id}
																					value={employee.real_name}
																					employee_id={employee.id}
																					style={{ width: column.valueWidthSelect }}>
																					{employee.real_name}
																				</Select.Option>
																			))}
																	</Select>
																)}
															</Form.Item>
														</Col>
													)
												case "department":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(
																	<TreeSelect placeholder="请选择部门"
																		style={{ width: column.valueWidth }}
																		showSearch={false}
																		autoExpandParent={true}
																		dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																		treeDefaultExpandAll >
																		{this.props.departmentsList &&
																			this.renderTreeNodes(this.props.departmentsList)}
																	</TreeSelect>
																)}
															</Form.Item>
														</Col>
													)
												case "departments":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey].map(value => value.id + "")
																})(
																	<TreeSelect placeholder="请选择部门"
																		multiple
																		style={{ width: column.valueWidth }}
																		showSearch={false}
																		autoExpandParent={true}
																		dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																		treeDefaultExpandAll >
																		{this.props.departmentsList &&
																			this.renderTreeNodes(this.props.departmentsList)}
																	</TreeSelect>
																)}
															</Form.Item>
														</Col>
													)
												case "people":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item>
																{this.props.form.getFieldDecorator("employee_ids", {
																	initialValue: this.props.dataSource[column.key].map(employee => employee.id)
																})(
																	<Select mode="multiple"
																		style={{ display: "none" }}
																		filterOption={false}>
																		{this.props.dataSource[column.key].map((employee, index) => (
																			<Select.Option key={index} value={employee.id + ""}>
																				{employee.id + ""}
																			</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.valueKey, {
																	rules: [{
																		required: column.required,
																		message: '请输入' + column.label
																	}],
																	initialValue: this.props.dataSource[column.valueKey].map(person => person.text)
																})(
																	<Select mode="multiple"
																		{...column.rules}
																		style={{ width: column.valueWidth }}
																		onSearch={this.selectEmployee}
																		filterOption={false}
																		onChange={this.changePeople.bind(this, column.key)}
																		placeholder={"请输入" + column.label}
																		onSelect={this.setPeople.bind(this, column.key)} >
																		{this.props.employees &&
																			this.props.employees.Data.map(employee => (
																				<Select.Option key={employee.id}
																					value={employee.real_name}
																					employee_id={employee.id}
																					style={{ width: column.valueWidthSelect }}>
																					{employee.real_name}
																				</Select.Option>
																			))}
																	</Select>
																)}
															</Form.Item>
														</Col>
													)
												case "checkbox":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请输入' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(
																	<Radio.Group style={{ width: column.valueWidth, textAlign: "left" }}>
																		{column.children.map((child, childIndex) => (
																			<Radio.Button key={childIndex}
																				value={child.id}>{child.text}</Radio.Button>
																		))}
																	</Radio.Group>
																)}
															</Form.Item>
														</Col>
													)
												case "select":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请选择' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(
																	<Select style={{ width: column.valueWidth, textAlign: "left" }}>
																		{column.children.map((child, childIndex) => (
																			<Select.Option key={childIndex}
																				style={{ width: column.valueWidthSelect }}
																				value={child.id}>{child.text}</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
														</Col>
													)
												case "multiSelect":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请选择' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey].map(value => value.id)
																})(
																	<Select style={{ width: column.valueWidth, textAlign: "left" }}
																		mode="multiple">
																		{column.children.map((child, childIndex) => (
																			<Select.Option key={child.id + ""}
																				style={{ width: column.valueWidthSelect }}
																				value={child.id + ""}>{child.text}</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
														</Col>
													)
												case "multiSelectex":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															<Form.Item label={column.label}>
																{this.props.form.getFieldDecorator(column.key, {
																	rules: [{ required: column.required, message: '请选择' + column.label }],
																	initialValue: this.props.dataSource[column.valueKey]
																})(
																	<Select style={{ width: column.valueWidth, textAlign: "left" }}
																		mode="multiple">
																		{column.children.map((child, childIndex) => (
																			<Select.Option key={child.id}
																				style={{ width: column.valueWidthSelect }}
																				value={child.id}>{child.text}</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
														</Col>
													)
												case "render":
													return (
														<Col key={index} span={column.span} style={{ display: column.hide ? "none" : "" }}>
															{column.render}
														</Col>
													)
												default:
													return null;
											}
										})}
									</Row>
								</Form>)
						case "error":
							return (
								<div style={{ textAlign: 'center', margin: '100px 0px' }}>
									{webConfig.httpFetchErrorInformation}
								</div>);
						case "loading":
						case "unload":
							return (
								<div style={{ textAlign: 'center', margin: '100px 0px' }}>
									<Spin size="large" />
								</div>);
						default:
							return null;
					}
				})()}
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/components/frame/DynamicForm.js